(function () {
  'use strict';

  function CzMegaIndicator(nav) {
    var list = nav.querySelector('.cz-mega-nav__list');
    var indicator = nav.querySelector('.cz-mega-nav__indicator');
    if (!list || !indicator) return;

    nav.classList.add('cz-mega-nav--js');

    // Sposta l'indicator nel .header-wrapper (suo positioned ancestor reale).
    // Così bottom: -1px lo allinea col border-bottom dell'header, non con il
    // bottom del nav (che ha del padding sotto).
    var anchor = nav.closest('.header-wrapper') || nav;
    if (indicator.parentElement !== anchor) {
      anchor.appendChild(indicator);
    }

    var items = Array.from(list.querySelectorAll('.cz-mega-nav__item'));
    var hovered = null;
    var rafId = null;

    function getActiveItem() {
      var openItem = list.querySelector('details.cz-mega[open]');
      if (openItem) return openItem.closest('.cz-mega-nav__item');
      var currentLink = list.querySelector('.cz-mega-nav__link[aria-current="page"], .cz-mega-nav__link[aria-current="true"]');
      if (currentLink) return currentLink.closest('.cz-mega-nav__item');
      var childActive = list.querySelector('.cz-mega-nav__item--child-active');
      if (childActive) return childActive;
      return null;
    }

    function moveTo(item) {
      if (!item) { hide(); return; }
      var link = item.querySelector('.cz-mega-nav__link');
      if (!link) { hide(); return; }
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        var anchorRect = anchor.getBoundingClientRect();
        var linkRect = link.getBoundingClientRect();
        indicator.style.left = (linkRect.left - anchorRect.left) + 'px';
        indicator.style.width = linkRect.width + 'px';
        indicator.style.opacity = '1';
      });
    }

    function hide() {
      indicator.style.opacity = '0';
    }

    function reset() {
      moveTo(getActiveItem());
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        hovered = item;
        moveTo(item);
      });
    });

    nav.addEventListener('mouseleave', function () {
      hovered = null;
      reset();
    });

    list.querySelectorAll('details.cz-mega').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!hovered) reset();
      });
    });

    var resizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        if (hovered) moveTo(hovered); else reset();
      }, 80);
    }, { passive: true });

    reset();
  }

  function init() {
    document.querySelectorAll('.cz-mega-nav').forEach(function (nav) {
      CzMegaIndicator(nav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
